var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,11.65A4.83,4.83,0,1,0,7.17,6.83,4.82,4.82,0,0,0,12,11.65ZM12,4.3A2.53,2.53,0,1,1,9.47,6.83,2.53,2.53,0,0,1,12,4.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12,13a8.51,8.51,0,0,0-8.51,8.5V22h2.3v-.46a6.21,6.21,0,0,1,12.41,0V22h2.3v-.46A8.51,8.51,0,0,0,12,13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.d2183488d1a2ebccec874f13a8ffaf4f.svg";
export { ForwardRef as ReactComponent };